import { connect } from 'react-redux';
import 'react-widgets/lib/less/react-widgets.less';
import { Edit as DictEdit, mapDispatchToProps } from '../Edit';
import { REF_NAME, REF_PATH } from './Const';
import { List as ImmutableList } from 'immutable';

class Edit extends DictEdit {
  constructor() {
    super();
    this.setRefPath(REF_PATH);
    this.setRefName(REF_NAME);
  }
}

export default connect((state, props) =>
  ({ saving: state.getIn(['allaround', 'saving'], false),
    refObject: state.getIn(['references', 'simple', REF_PATH], new ImmutableList())
      .find(r => r.get('id') == props.params.refId) }),
mapDispatchToProps(REF_NAME, REF_PATH))(Edit);
